export default __webpack_public_path__ + "static/Lato-Regular-9d883d540ee2b4de80247a522dd59656.ttf";